import { LayoutDashboard, Shield, BookOpen, Users, Settings, Upload, FileText, Star } from "lucide-react";
import type { UserRole } from "@/api/types/user-management.types";

/**
 * Role badge color configuration
 * Used in UserDropdown to display role badges with distinct colors
 */
export const roleColors: Record<UserRole, string> = {
  PUBLISHER: "bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300",
  ALC_BACKOFFICE_OVERVIEW: "bg-sky-100 text-sky-700 dark:bg-sky-900 dark:text-sky-300",
  ALC_BACKOFFICE_BOOK_REVIEWER: "bg-teal-100 text-teal-700 dark:bg-teal-900 dark:text-teal-300",
  ALC_BACKOFFICE_MANAGER: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900 dark:text-emerald-300",
  ALC_BACKOFFICE_CONTENT_RATING: "bg-violet-100 text-violet-700 dark:bg-violet-900 dark:text-violet-300",
  ARABOOKVERSE_BACKOFFICE: "bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-300",
  ADMIN: "bg-rose-100 text-rose-700 dark:bg-rose-900 dark:text-rose-300",
};

/**
 * Menu item configuration
 */
export interface MenuItemConfig {
  icon: React.ComponentType<{ className?: string }>;
  labelKey: string; // i18n translation key
  path: string;
  roles: UserRole[]; // Required roles to see this menu item
}

/**
 * User dropdown menu items configuration
 * Items are rendered in order, filtered by user's roles
 */
export const menuItems: MenuItemConfig[] = [
  // Publisher
  {
    icon: LayoutDashboard,
    labelKey: "nav.publisherDashboard",
    path: "/publisher/dashboard",
    roles: ["PUBLISHER"],
  },
  {
    icon: Upload,
    labelKey: "nav.uploadBooks",
    path: "/publisher/uploadMetaData",
    roles: ["PUBLISHER"],
  },
  // ALC Backoffice Overview
  {
    icon: Shield,
    labelKey: "nav.alcOverviewDashboard",
    path: "/alc/overview",
    roles: ["ALC_BACKOFFICE_OVERVIEW"],
  },
  // ALC Book Reviewer
  {
    icon: BookOpen,
    labelKey: "nav.alcBookReviewerDashboard",
    path: "/alc/book-reviewer",
    roles: ["ALC_BACKOFFICE_BOOK_REVIEWER"],
  },
  // ALC Manager
  {
    icon: Users,
    labelKey: "nav.alcManagerDashboard",
    path: "/alc/manager",
    roles: ["ALC_BACKOFFICE_MANAGER"],
  },
  // ALC Content Rating
  {
    icon: Star,
    labelKey: "nav.alcContentRatingDashboard",
    path: "/alc/content-rating/tasks",
    roles: ["ALC_BACKOFFICE_CONTENT_RATING"],
  },
  // Arabookverse Backoffice
  {
    icon: Shield,
    labelKey: "nav.arabookverseDashboard",
    path: "/arabookverse/dashboard",
    roles: ["ARABOOKVERSE_BACKOFFICE"],
  },
  {
    icon: FileText,
    labelKey: "nav.contractReview",
    path: "/alc/contracts",
    roles: ["ARABOOKVERSE_BACKOFFICE"],
  },
  {
    icon: Settings,
    labelKey: "nav.cms",
    path: "/cms/dashboard",
    roles: ["ARABOOKVERSE_BACKOFFICE", "ADMIN"],
  },
];
